import React from 'react';
import './StatCard.css';

/**
 * Composant carte KPI pour afficher une statistique
 * @param {string} title - Titre de la statistique
 * @param {string|number} value - Valeur principale
 * @param {string} suffix - Suffixe (ex: %)
 * @param {number} change - Variation par rapport à la période précédente
 * @param {string} icon - Icône (emoji ou composant)
 */
function StatCard({ title, value, suffix = '', change = null, icon = null }) {
    const formatValue = (val) => {
        if (typeof val === 'number') {
            if (val >= 1000000) {
                return (val / 1000000).toFixed(1) + 'M';
            }
            if (val >= 1000) {
                return (val / 1000).toFixed(1) + 'k';
            }
            return val.toLocaleString('fr-FR');
        }
        return val;
    };

    const getChangeClass = () => {
        if (change === null || change === 0) return 'neutral';
        return change > 0 ? 'positive' : 'negative';
    };

    const formatChange = () => {
        if (change === null) return null;
        const sign = change > 0 ? '+' : '';
        return `${sign}${change}%`;
    };

    return (
        <div className="stat-card">
            <div className="stat-card-header">
                {icon && <span className="stat-icon">{icon}</span>}
                <span className="stat-title">{title}</span>
            </div>
            <div className="stat-card-body">
                <span className="stat-value">
                    {formatValue(value)}
                    {suffix && <span className="stat-suffix">{suffix}</span>}
                </span>
                {change !== null && (
                    <span className={`stat-change ${getChangeClass()}`}>
                        {formatChange()}
                    </span>
                )}
            </div>
        </div>
    );
}

export default StatCard;
